import React, { FC } from 'react';

interface IfProps {
  condicao: boolean
  children: React.ReactNode
}

export const If: FC<IfProps> = ({condicao, children}) => {
  return <>
    {condicao && children}
  </>
}